import styled from 'styled-components';
import InputMask from 'react-input-mask';

export const InputContainer = styled.div`
  margin-bottom: 3vw;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 1.6vw;
  box-sizing: border-box;
  padding-left: 3.6vw;
  font-weight: 400;
  font-size: 3.3vw;
  font-family: 'Libre Franklin', sans-serif;
`;

export const Input = styled(InputMask)`
  width: ${(props) => props.inputwidth || '89.33vw'};
  height: 13.333vw;
  margin-bottom: 2.4vw;
  border: solid 1px ${(props) => props.colorborder};
  border-radius: 2.666vw;
  box-sizing: border-box;
  padding-left: 3.733vw;
  font-size: 4vw;
  outline: none;

  ::placeholder {
    font-family: 'Libre Franklin', sans-serif;
    color: #cccccc;
    font-size: 3.733vw;
  }

  &:focus {
    border: 1px solid black;
  }

  &:disabled {
    opacity: 0.5;
  }
`;
